import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
    Menu: any[] = [];
    sidebarTitle: string;

    constructor(private _router: Router) {
        this.sidebarTitle = "Multitenant.dealpos.app"
    }

    ngOnInit(): void {
        this.Menu = [
            {
                Icon: "fa-solid fa-chart-area",
                Target: null,
                Title: "Report",
                Url: '/menu/report'
            },
            {
                Icon: "fa-solid fa-cog",
                Target: null,
                Title: "Channel",
                Url: '/menu/channel'
            }
        ];
    }

    LogOut(): void {
        window.localStorage.removeItem("user");
        this._router.navigate(['']);
    }
}
